// In-memory stash for the display name an auth provider handed us during
// sign-in (Sign in with Apple delivers it ONLY in the first authorization
// response — it is not in the identity token, so if it isn't kept here it is
// unrecoverable). authUtils writes it after the credential exchange succeeds;
// the onboarding wizard reads it as a fallback when the Firebase profile
// write failed, so a transient network error can never resurrect the "type
// your name" prompt Apple rejected (App Store Guideline 4).
//
// Lives in its own dependency-free module (not authUtils) so the wizard can
// import it without dragging the router/view import chain into component
// tests. Keyed by uid and only ever set post-sign-in: an account switched to
// in the same JS context must never inherit the previous user's name.
let pending = null;

export const providerNameStore = {
  set(uid, name) {
    pending = { uid, name };
  },
  clear() {
    pending = null;
  },
  // Returns "" unless the stash belongs to exactly this uid.
  getFor(uid) {
    return uid && pending?.uid === uid ? pending.name : "";
  },
};
